import React, { type ReactNode } from "react";

import { TruncatedTextWithTooltip } from "@/components/flowbite/truncated-text-with-tooltip";
import Typography from "@/components/flowbite/typography/typography";

interface SectionTitleProps {
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  title: string;
  trailing?: ReactNode;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  icon: Icon,
  title,
  trailing,
}) => {
  return (
    <div className="sticky top-0 z-10 -mx-3 flex items-center justify-between gap-2 bg-white px-3 py-2">
      <div className="flex min-w-0 items-center gap-2">
        {Icon && <Icon />}
        <Typography.Title
          capitalize={false}
          className="min-w-0 flex-1 overflow-hidden"
          colorShade={400}
        >
          <TruncatedTextWithTooltip text={title} />
        </Typography.Title>
      </div>
      {trailing != null ? (
        <div className="flex shrink-0 items-center self-center">{trailing}</div>
      ) : null}
    </div>
  );
};
